let locales = {
    ModalHistoryNotesByPAState_title: 'Resumen de todas las notas de este paso',
    ModalHistoryNotesByPAState_dateCreatedNote: 'Fecha de creacion de la nota'
};

export default locales;